
// Member Targets!!! Should not be used any more
export class Targets {
    constructor(targets) {
        this.targets = targets;
    }

    static makeId(year, email){
        return year+"/"+email;
    }

    getCurrentTargets() {
        return this.getTargets(Date.now())
    }

    getTargets(date) {
        var date1=new Date(date);
        if (!this.targets || !this.targets.Dates)
            return undefined;
        var pastValues=this.targets.Dates.filter(x=> new Date(x.Date) <= date1);
        return pastValues[0];
    }

}